import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  filteredProducts: [],
};

const filterSlice = createSlice({
  name: "filter",
  initialState,
  reducers: {
    FILTER_BY_SEARCH(state, action) {
      const { products, search } = action.payload;
      if (search) {
        const tempProducts = products.filter(
          (product) =>
            product.name.toLowerCase().includes(search.toLowerCase()) ||
            product.category.toLowerCase().includes(search.toLowerCase())
        );

        state.filteredProducts = tempProducts;
      }
    },
    FILTER_BY_SEARCHPRODUCTS(state, action) {
      const { products, search } = action.payload;
      const tempProducts = products.filter(
        (product) =>
          product.name.toLowerCase().includes(search.toLowerCase()) ||
          product.category.toLowerCase().includes(search.toLowerCase())
      );

      state.filteredProducts = tempProducts;
    },
    FILTER_BY_CATEGORY(state, action) {
      const { products, category } = action.payload;
      let tempProducts = [];
      if (category === "All") {
        tempProducts = products;
      } else {
        tempProducts = products.filter(
          (product) => product.category === category
        );
      }

      state.filteredProducts = tempProducts;
    },
    FILTER_BY_SUB_CATEGORY(state, action) {
      const { products, subCategory } = action.payload;
      let tempProducts = [];
      if (subCategory === "All") {
        tempProducts = products;
      } else {
        tempProducts = products.filter(
          (product) => product.subCategory === subCategory
        );
      }

      state.filteredProducts = tempProducts;
    },
    SORT_PRODUCTS(state, action) {
      const { products, sort } = action.payload;
      let tempProducts = [...products];

      if (sort === "latest") {
        // No sorting needed for 'latest'
      } else if (sort === "lowest-price") {
        tempProducts.sort((a, b) => a.price - b.price);
      } else if (sort === "highest-price") {
        tempProducts.sort((a, b) => b.price - a.price);
      } else if (sort === "a-z") {
        tempProducts.sort((a, b) => a.name.localeCompare(b.name));
      } else if (sort === "z-a") {
        tempProducts.sort((a, b) => b.name.localeCompare(a.name));
      }

      state.filteredProducts = tempProducts;
    },
    FILTER_BY_BRAND(state, action) {
      const { products, brand } = action.payload;
      let tempProducts = [];
      if (brand === "All") {
        tempProducts = products;
      } else {
        tempProducts = products.filter((product) => product.brand === brand);
      }
      state.filteredProducts = tempProducts;
    },
    FILTER_BY_SPORT(state, action) {
      const { products, sport } = action.payload;
      let tempProducts = [];

      if (sport === "All") {
        tempProducts = products;
      } else {
        tempProducts = products.filter((product) => product.sport === sport);
      }

      state.filteredProducts = tempProducts;
    },
    FILTER_BY_PRICE(state, action) {
      const { products, price } = action.payload;
      let tempProducts = [];
      tempProducts = products.filter((product) => product.price <= price);

      state.filteredProducts = tempProducts;
    },
  },
});

export const {
  FILTER_BY_SEARCH,
  FILTER_BY_SEARCHPRODUCTS,
  FILTER_BY_CATEGORY,
  SORT_PRODUCTS,
  FILTER_BY_BRAND,
  FILTER_BY_SPORT,
  FILTER_BY_PRICE,
  FILTER_BY_SUB_CATEGORY,
} = filterSlice.actions;

export const selectFilteredProducts = (state) => {
  console.log(state);
  
  return state.filter.filteredProducts;
};

export default filterSlice.reducer;